import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseWork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSuitcaseWork"><Path fillRule="evenodd" clipRule="evenodd" d="M7 2H17V6H22V21H2V6H7V2ZM9 6H15V4H9V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSuitcaseWork;
